export default {
  manningVessels: [],
  crewRoles: [],
  boardingStatusList: [
    { id: '1', name: '乗船'},
    { id: '2', name: '下船'},
    { id: '3', name: '管理期間外'},
  ],
  isLaborAdminList: [
    { id: 1,  name: 'あり'},
    { id: 0,  name: 'なし'},
  ],

};
